module.exports = "/static/assets/64390a79871b775efaf2daa11e30dc84.png";